module.exports = __webpack_public_path__ + "image/darkgreen_icon_shubiao.png";